import './App.css';
import { useState } from 'react';
import DateChooser from './components/DateChooser';
import ResortTable from './components/ResortTable';


function App() {
  const [resortData, setResortData] = useState([]);

  const onDataAvailable = (result) => {
    setResortData(result);
  }

  return (
    <div className="App">
     
    <DateChooser onDataAvailable={onDataAvailable}></DateChooser>
    
    {resortData.length > 0 &&
      <h3>Walt Disney World Resorts</h3>
    }
    {resortData.map(resort => (
      <ResortTable data={resort} location={'wdw'}></ResortTable>
    ))}
    
    {resortData.length > 0 &&
      <h3>Other Resorts</h3>
    }
    {resortData.map(resort => (
      <ResortTable data={resort} location={'other'}></ResortTable>
    ))}
    
    </div>
  );
}

export default App;
